import { androidHandler } from './androidHandler'

export function isPmmBelowVersion(minVersion: number): boolean {
  const handler = androidHandler()
  return handler.getAppType() === 'PMM' && handler.getVersion() < minVersion
}

export function isNativeFeatureEnabled(pmmMinVersion: number): boolean {
  const handler = androidHandler()
  const type = handler.getAppType()
  return (
    type === 'RUMDIK' ||
    (type === 'PMM' && handler.getVersion() >= pmmMinVersion)
  )
}
